import * as React from "react";
import Table from "../data/Table";
import { useDataSource } from "../data/Source";
import { FormOption } from "../data/Types";
import { text } from "../data/fields/Fields";
import { StandardForm } from "../data/Editor";
import { FieldContext, MetaContext } from "../store/Context";
import { Typography } from '@mui/joy';

function renderDecorator(row: any) {
    return row.code ? row.code.charAt(0) : '?';
}

function renderItem(row: any) {
    return (
        <div>
            <Typography fontWeight={600} sx={{ width: '100%' }} gutterBottom>
                {row.code}
            </Typography>
            <Typography level="body-xs">
                {row.name} &bull; {row.region}
            </Typography>
        </div>
    );
}

const metadata = {
    primary: 'code',
    table: 'countries',
    single: 'country',
    zone: false,
    renderDecorator,
    renderItem,
    headers: [
        { title: 'Code', name: 'code' },
        { title: 'Name', name: 'name' },
        { title: 'Region', name: 'region' }
    ]
}
const fields = [
    text('Code', 'code', true),
    text('Name', 'name', true),
    text('Region', 'region')
]

export function useCountryOptions() {
    const { table, primary, zone } = metadata;
    const [countryOptions, setOptions] = React.useState<FormOption[] | null>(null);
    const listData = useDataSource(table, zone);
    React.useEffect(() => {
        if (!listData.isLoading) {
            setOptions(listData.items.map((item: any) => ({ 'id': item[primary], 'label': item['name'] })))
        }
    }, [listData.isLoading, listData.items, primary, setOptions])

    return countryOptions;
}

export default function Countries() {
    return <MetaContext.Provider value={metadata}>
        <FieldContext.Provider value={fields}>
            <Table form={<StandardForm />} />
        </FieldContext.Provider>
    </MetaContext.Provider>;
}